import { TipoModalAndamento } from './tipo-modal-andamento.model';

export interface ClasseAndamento {
  CODCLASSE?: number;
  TITULO: string;
  DESCRICAO: string;
  ICONE: string;
  PATH: string;
  CODTIPOFLUXO: EnumTiposFluxoAndamento;
  TIPOFLUXO: string;
  TIPOFLUXOANDAMENTO: TipoFluxoAndamento;
  PRAZO: number;
  MODALANDAMENTO?: TipoModalAndamento;
  TITULODESPACHOANDAMENTO?: string;
  EXCLUSIVOSISTEMA: boolean; // Se true, não pode ser executado manualmente pelo usuário
}

export interface RestricaoCategoriaClasseAndamento {
  CODRESTRICAOCATEGORIACLASSEANDAMENTO?: number;
  CODCATEGORIASOLICITACAO: number;
  CODCLASSE: number;
}

export enum EnumClassesAndamento {
  CLASSIFICACAO_NOVA_FUNCIONALIDADE = 'clnvfu',
  CLASSIFICACAO_CORRECAO_ERRO = 'clcrer',
  CLASSIFICACAO_AJUSTES_MELHORIAS = 'clajme',
  CLASSIFICACAO_SUPORTE_ORIENTACAO = 'supuse',
  CLASSIFICACAO_USUARIOS_ACESSOS = 'caduse',
  CLASSIFICACAO_CURSOS = 'crtcrs',
  CLASSIFICACAO_PLATAFORMA = 'confsi',
  CLASSIFICACAO_UNIDADES_LOTACOES = 'clunlo',
  ATENDIMENTO = 'atendi',
  ABERTURA = 'abertu',
  ENVIO = 'enviar',
  TRANSFERENCIA = 'transf',
  RECEBIMENTO = 'recebi',
  RECUSA = 'recusa',
  DEVOLUCAO = 'devolu',
  DESPACHO = 'despac',
  PENDENCIA_DOCUMENTO = 'pnddoc',
  ENVIO_DOCUMENTOS = 'envdoc',
  SOLICITACAO_ASSUMIDA = 'asmsol',
  SOLICITACAO_REQUISITADA = 'reqsol',
  REQUISICAO_SOLICITACAO_APROVADA = 'aprreq',
  REQUISICAO_SOLICITACAO_NEGADA = 'negreq',
  CANCELAMENTO = 'cancel',
  FINALIZACAO = 'finali',
  CONCLUSAO = 'conclu',
  HOMOLOGACAO_PROTEC = 'hprtec',
  SUBSTITUICAO_PECAS = 'subpec',
  INCLUSAO_EQUIPAMENTOS = 'inceqt',
  APROVACAO_HOMOLOGACAO_SOLICITACAO = 'aprhom',
  ENVIO_NOTA_FISCAL = 'envnfi',
  ENVIO_TAXAS = 'envtax',
  DOCUMENTACAO_EXERCITO = 'docexe',
  OFICIO_BRASILIA = 'ofcbsb',
  ANEXAR_SOLICITACAO = 'anxsol',
  DESANEXA_SOLICITACAO = 'dnxsol',
  RETORNO_PARA_ANDAMENTO = 'return',
  INTERACAO = 'msgsol',
  RESPOSTA_INTERACAO = 'resmsg',
}

export enum EnumTiposFluxoAndamento {
  PRINCIPAL = 1,
  MOVIMENTACAO = 2,
  COMPLEMENTAR = 3,
}

export interface TipoFluxoAndamento {
  CODTIPOFLUXO: EnumTiposFluxoAndamento;
  TITULO: string;
}

export const LISTA_TIPO_FLUXO_ANDAMENTO: readonly TipoFluxoAndamento[] = [
  { CODTIPOFLUXO: EnumTiposFluxoAndamento.PRINCIPAL, TITULO: 'Principal' },
  { CODTIPOFLUXO: EnumTiposFluxoAndamento.MOVIMENTACAO, TITULO: 'Movimentação' },
  { CODTIPOFLUXO: EnumTiposFluxoAndamento.COMPLEMENTAR, TITULO: 'Complementar' },
];

// Mapa de PATH → TIPOFLUXO para os paths confirmados como call sites de executaAndamentoByOutside.
// Paths fora deste mapa são resolvidos via fallback silencioso: GET /classeandamento?path=xxx.
export const PATH_TIPO_FLUXO_MAP: Readonly<Partial<Record<EnumClassesAndamento, EnumTiposFluxoAndamento>>> = {
  [EnumClassesAndamento.INCLUSAO_EQUIPAMENTOS]: EnumTiposFluxoAndamento.PRINCIPAL,
  [EnumClassesAndamento.RECEBIMENTO]: EnumTiposFluxoAndamento.MOVIMENTACAO,
  [EnumClassesAndamento.RECUSA]: EnumTiposFluxoAndamento.MOVIMENTACAO,
  [EnumClassesAndamento.TRANSFERENCIA]: EnumTiposFluxoAndamento.MOVIMENTACAO,
  [EnumClassesAndamento.SOLICITACAO_ASSUMIDA]: EnumTiposFluxoAndamento.COMPLEMENTAR,
  [EnumClassesAndamento.SOLICITACAO_REQUISITADA]: EnumTiposFluxoAndamento.MOVIMENTACAO,
  [EnumClassesAndamento.REQUISICAO_SOLICITACAO_APROVADA]: EnumTiposFluxoAndamento.MOVIMENTACAO,
  [EnumClassesAndamento.REQUISICAO_SOLICITACAO_NEGADA]: EnumTiposFluxoAndamento.MOVIMENTACAO,
  [EnumClassesAndamento.DESANEXA_SOLICITACAO]: EnumTiposFluxoAndamento.COMPLEMENTAR,
  [EnumClassesAndamento.CANCELAMENTO]: EnumTiposFluxoAndamento.COMPLEMENTAR,
  [EnumClassesAndamento.INTERACAO]: EnumTiposFluxoAndamento.COMPLEMENTAR,
  [EnumClassesAndamento.RESPOSTA_INTERACAO]: EnumTiposFluxoAndamento.COMPLEMENTAR,
} as const;

export const CLASSES_CLASSIFICACAO_SISTEMAS: ReadonlySet<string> = new Set([
  EnumClassesAndamento.CLASSIFICACAO_NOVA_FUNCIONALIDADE,
  EnumClassesAndamento.CLASSIFICACAO_CORRECAO_ERRO,
  EnumClassesAndamento.CLASSIFICACAO_AJUSTES_MELHORIAS,
  EnumClassesAndamento.CLASSIFICACAO_SUPORTE_ORIENTACAO,
  EnumClassesAndamento.CLASSIFICACAO_USUARIOS_ACESSOS,
  EnumClassesAndamento.CLASSIFICACAO_CURSOS,
  EnumClassesAndamento.CLASSIFICACAO_PLATAFORMA,
  EnumClassesAndamento.CLASSIFICACAO_UNIDADES_LOTACOES,
]);
